import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import Skeleton from 'react-loading-skeleton'
import moment from 'moment'
import { NavLink, useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Padlock, Bin, Checked, Pallet } from '../../../../assets/icons'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import { Button, Spinner } from '../../../../UI'
import {
  deleteAdmin,
  toggleAdminStatus,
  getSpecificUserActivity,
  getSpecificAdmin,
} from '../../../../store/actions'
import Container from './styles'

const AdminDetails = () => {
  const navigate = useNavigate()
  const params = useParams()
  const dispatch = useDispatch()
  const { adminLists } = useSelector((s) => s.AdminData)
  const [activeAdminIndex, setActiveIndex] = useState(0)
  const [{ loading, activityLoading }, setLoading] = useState({
    loading: false,
    activityLoading: false,
  })
  const [activityLists, setActivityLists] = useState([])
  const [adminData, setAdminData] = useState(() => {
    if (adminLists) {
      return adminLists.data.find((item) => item.id === params.adminId)
    } else {
      return ''
    }
  })

  const handleSetActivity = ({ status, data }) => {
    setActivityLists(data.audits)
  }

  useEffect(() => {
    setLoading((s) => ({
      ...s,
      activityLoading: true,
    }))
    if (!adminData) {
      dispatch(getSpecificAdmin(params.adminId)).then((response) => {
        if (response && response.data) {
          setAdminData(response.data)
          getSpecificUserActivity(response.data.email).then(handleSetActivity)
        }
      })
    } else if (adminData) {
      getSpecificUserActivity(adminData.email).then(handleSetActivity)
    }
  }, [adminData, params, dispatch])

  useEffect(() => {
    if (adminLists) {
      const newAdminData = adminLists.data.find(
        (item) => item.id === params.adminId,
      )
      if (newAdminData) setAdminData(newAdminData)
    }
  }, [adminLists, params])

  const handleNavClick = (action) => {
    let activeIndex = adminLists.data.findIndex(
      (item) => item.id === params.adminId,
    )
    if (action === 'prev') {
      activeIndex -= 1
    } else {
      activeIndex += 1
    }
    navigate(`/dashboard/admins/${adminLists.data[activeIndex].id}/details`)
    setActiveIndex(activeIndex)
  }

  const handleAdminAction = (action) => {
    setLoading((s) => ({
      ...s,
      loading: action,
    }))
    
    const apiCall = action === 'delete'
      ? dispatch(deleteAdmin(params.adminId))
      : dispatch(toggleAdminStatus(params.adminId))
    
    apiCall
      .then((response) => {
        setLoading({ loading: false, activityLoading })
          // Navigate back to admin list after successful delete
          navigate('/dashboard/admins')
       })
      .catch(() => {
        setLoading({ loading: false, activityLoading })
      })
  }

  return (
    <Container>
      <header>
        <div className="row-1">
          <NavLink to="/dashboard/admins" exact={true}>
            Admins
          </NavLink>
          {adminData && (
            <NavLink
              to={`/dashboard/admins/${params.adminId}/details`}
              exact={true}
            >
              {adminData.firstName} {adminData.lastName}
            </NavLink>
          )}
        </div>
        <div className="row-2">
          <Button
            icon
            disabled={activeAdminIndex === 0}
            arial-label="prev admin"
            onClick={() => handleNavClick('prev')}
          >
            <IoIosArrowBack />
          </Button>
          <Button
            icon
            disabled={activeAdminIndex === adminLists?.data?.length - 1}
            arial-label="next admin"
            onClick={() => handleNavClick('next')}
          >
            <IoIosArrowForward />
          </Button>
        </div>
      </header>
      <div className="admin--details__container">
        <div className="content--container">
          <div className="profile--row">
            <div className="col-1">
              <div className="img--contents">
                <div className="img--container">
                  {adminData
                    ? `${adminData.firstName[0]}${adminData.lastName[0]}`
                    : 'PO'}
                </div>
                {/* <Button
                  onClick={() =>
                    navigate(`/dashboard/admins/update`, {
                      adminId: params.adminId,
                    })
                  }
                >
                  Edit Profile
                </Button> */}
              </div>
              <div className="profile--content">
                <h3>
                  {adminData ? (
                    `${adminData.firstName} ${adminData.lastName}`
                  ) : (
                    <Skeleton width={'10rem'} />
                  )}
                </h3>
                <p>
                  {adminData ? adminData.email : <Skeleton width={'9rem'} />}
                </p>
                <p>
                  {adminData ? (
                    adminData.phone
                  ) : (
                    <Skeleton width={'8rem'} />
                  )}
                </p>
                <p className="offline">Offline</p>
              </div>
            </div>
            <div className="col-2">
              <Button
                icon
                onClick={() =>
                  navigate(`/dashboard/admins/resetPassword`, {
                    adminId: params.adminId,
                  })
                }
              >
                <Padlock />
                Reset Password
              </Button>
              <Button
                className={`btn-status btn-${adminData.status}`}
                loading={loading === 'inactive' || loading === 'active'}
                spinnerWithTxt
                onClick={() =>
                  handleAdminAction(
                    adminData.status === 'ACTIVE' ? 'inactive' : 'active',
                  )
                }
              >
                {adminData.status === 'ACTIVE' ? 'Deactivate' : 'Activate'}{' '}
                account
              </Button>
              <Button
                icon
                loading={loading === 'delete'}
                className="btn--delete"
                spinnerWithTxt
                onClick={() => handleAdminAction('delete')}
              >
                <Bin />
                Delete account
              </Button>
            </div>
          </div>
          <div className="activities--container">
            <h3>Recent Activities</h3>
           
          </div>
        </div>
      </div>
    </Container>
  )
}

export default AdminDetails
